export default "__VITE_ASSET__BZba$iw1__"